import { SessionSiteSelectors } from '~src/bootstrap/redux/selectors/SessionInfoSelectors';
import { FeatureFlags } from '~src/commonInfra/featureFlags/FeatureFlags';

import { Messages } from '../../../../codegen/Localize';
import { publishToSalesforce } from '../../../actions/PublishToSalesforceActions';
import { IPublishToSalesforceAction } from '../../../models/actionNames';
import { IContentInfo } from '../../../models/IContentInfo';
import { EntityActionNames, IEntityAction } from './IEntityAction';

export const PublishToSalesforceAction: IEntityAction<IContentInfo, IPublishToSalesforceAction> = {
  name: EntityActionNames.PublishToSalesforce,
  translateName: Messages.publishToSalesforceAction,
  isVisible: (_, state) => {
    return FeatureFlags.publishViewToSalesforce
      && SessionSiteSelectors.isSessionCanPublish(state);
  },
  isClickable: (availableActions: IPublishToSalesforceAction, targetItems: IContentInfo[], state) => {
    if (targetItems.length > 1) {
      return SessionSiteSelectors.isPublishToSalesforceEnabled(state);
    } else {
      return !!(availableActions && availableActions.publishToSalesforce);
    }
  },
  createReduxAction: (targetItems: IContentInfo[]) => publishToSalesforce(targetItems)
};